const PER_PAGE = 100;
import { local_currencies } from "./Currencies";

export const BankAccountsApi = {
  /**
   * Only get from url and resolve SuccessFn or ErrorFn
   *
   * @param {Vue.Component} componentCaller a vue component.
   * @param {string}        url             field located in bankAccounts from state componentCaller.
   * @param {function}      successFn       callback function for success
   * @param {function}      errorFn         callback function for error
   * @param {object}        params          {per_page: number, last_id: UUID, filter: object with fields and value taht send in query_params ?filter=}
   */
  onlyGet(componentCaller, url, successFn, errorFn, params = {}) {
    params = _mountParams(params, [])
    _call(componentCaller, url, params, successFn, errorFn)
  },

  /**
   * Load bank accounts and append into selected `field` predefined in Vue component state.bank_accounts
   *
   * @param {Vue.Component} componentCaller               a vue component.
   * @param {string}        field                         field located in bankAccounts from state componentCaller.
   * @param {string}        url                           url from get data
   * @param {object}        params                        {per_page: number, last_id: UUID, filter: object with fields and value taht send in query_params ?filter=}
   * @param {object}       format_bank_name                        options to format bank_name
   * @param {boolean}      format_bank_name.show_facilita_bank_accounts  format bank_name to predefined pattern
   * @param {boolean}      format_bank_name.is_facilita_account                  format bank_name if is facilita_account
   */
  loadBankAccountIntoField(componentCaller, field, url, params = {}, format_bank_name) {
    params = _mountParams({...params}, componentCaller.bankAccounts[field])
    _call(componentCaller, url, params, function(data){
      const data0 = data.body.data.map(item => _addBankNameAndAccountType(item, format_bank_name))
      componentCaller.$set(componentCaller.bankAccounts, field, componentCaller.bankAccounts[field].concat(data0));
      componentCaller.$set(componentCaller.bankAccounts, field+'LoadedAt', (new Date).getTime());
      componentCaller.$set(componentCaller.bankAccounts, 'reachLimit'+(field[0].toUpperCase())+field.slice(1), _hasReachLimit(data0, params));
    })
  },
  /**
   * Load bank accounts with account_number_or_nickname or account_number filter
   *
   * @param {Vue.Component} componentCaller a vue component.
   * @param {string}        url             url from get data
   * @param {function}      successFn       callback function for success
   * @param {function}      errorFn         callback function for error
   * @param {string}        value           value for filter
   */
  loadBankAccountByNumberOrNickname(componentCaller, url, successFn, errorFn, value) {
    if(value.length >= 3) {
      const isAdmin = componentCaller.$cookies.isKey('admin') && componentCaller.$cookies.get('admin') === 'true'
      const params = {
        filter: isAdmin ? 'account_number_or_nickname' : 'account_number',
        filter_value: value
      }
      _call(componentCaller, url, params, successFn, errorFn)
    }
  },
  /**
   * Reload bank account and replace in defined array (field).
   *
   * @param {Vue.Component} componentCaller               a vue component.
   * @param {string}        field                         field located in bankAccounts from state componentCaller.
   * @param {object}        bankAccount                   bank account item to replace
   */
  reloadOneBankAccount(componentCaller, field, bankAccount) {
    const index = componentCaller.bankAccounts[field].findIndex(oldItem => oldItem.id == bankAccount.id)
    const url = componentCaller.$root.urls.admin__bank_accounts_one.replace('ID', bankAccount.id)
    _call(componentCaller, url, {}, function(data){
      const bankAccountUpdated = _addBankNameAndAccountType(data.body.data)
      componentCaller.bankAccounts[field].splice(index, 1, bankAccountUpdated)
    })
  },
  /**
   * update bank account in array that exists in
   *
   * @param {Vue.Component} componentCaller               a vue component.
   * @param {string}        field                         field located in bankAccounts from state componentCaller.
   * @param {object}        bankAccount                   bank account item to replace
   */
  updateOneBankAccount(componentCaller, field, bankAccount) {
    const index = componentCaller.bankAccounts[field].findIndex(oldItem => oldItem.id == bankAccount.id)
    const bankAccountUpdated = _addBankNameAndAccountType(bankAccount)
    componentCaller.bankAccounts[field].splice(index, 1, bankAccountUpdated)
  },
  /**
   * push bank account in array that exists in.
   *
   * @param {Vue.Component} componentCaller               a vue component.
   * @param {string}        field                         field located in bankAccounts from state componentCaller.
   * @param {object}        bankAccount                   bank account item to replace
   */
  insertOneBankAccount(componentCaller, field, bankAccount) {
    componentCaller.bankAccounts[field].push(_addBankNameAndAccountType(bankAccount))
  },
  /**
   * delete bank account in array that exists in field.
   *
   * @param {Vue.Component} componentCaller               a vue component.
   * @param {string}        field                         field located in bankAccounts from state componentCaller.
   * @param {object}        bankAccount                   bank account item to replace
   */
  deleteOneBankAccount(componentCaller, field, bankAccount) {
    const index = componentCaller.bankAccounts[field].findIndex(oldItem => oldItem.id == bankAccount.id)
    componentCaller.bankAccounts[field].splice(index, 1)
  },
}

  // private helpers functions
function _call(componentCaller, url, params, successFn, errorFn0 = null) {
  const token = componentCaller.$cookies.get('api_token')
  let errorFn = function(error) {
    console.error(error)
    if(typeof errorFn0 == "function") {
      errorFn0(error)
    }
  }
  componentCaller.$http.get(url, {params, headers: { Authorization: `Bearer ${token}` }}).then(successFn, errorFn)
}

function _mountParams(params, list) {
  const per_page = params["per_page"] || PER_PAGE
  const last_id = params["last_id"] || (list.length > 0 ? list[list.length - 1].id : null)
  const filter = params["filter"] || null
  const not_exclusive = params["not_exclusive"]

  return {per_page, last_id, filter, not_exclusive}
}

function _hasReachLimit(data, params){
  return data.length == 0 || data.length < params.per_page
}

function _addBankNameAndAccountType(bank_account, format_bank_name = {}) {
  const { show_facilita_bank_accounts = false, is_facilita_account = false } = format_bank_name;
  const { bank } = bank_account;
  let bank_name;

  if (bank.code) {
    bank_name = `${bank.code} - ${bank.name}`;
  } else if (bank.ispb) {
    bank_name = `${bank.ispb} - ${bank.name}`;
  } else if (bank.swift === bank.name) {
    bank_name = bank.name;
  } else if (is_facilita_account) {
    bank_name = show_facilita_bank_accounts
      ? `${bank.swift} - ${bank.name}`
      : bank.name;
  } else {
    bank_name = `${bank.code || bank.swift} - ${bank.name}`;
  }

  const account_type = local_currencies.includes(bank_account.currency) ? bank_account.account_type : 'internacional';

  return { ...bank_account, bank_name, account_type };
}



// WEBPACK FOOTER //
// ./src/shared/BankAccountsApi.js